const module = { name: 'discovery/moviesByComingSoon/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as pagination } from 'swug-fdRequire-call:discovery/moviesByComingSoon/pagination';

function run() {
    checkDependencies(module.name, debugLog);
    pagination.attach();
}
run();
export default module.exports;